import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Optional Bearer token for Admin "Test Mode" impersonation. Stored in
// sessionStorage (tab-scoped) rather than localStorage to limit XSS surface
// and to match the design intent of "one test session per tab".
api.interceptors.request.use((config) => {
  try {
    const tok = typeof window !== "undefined" && window.sessionStorage.getItem("impersonation_token");
    if (tok) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${tok}`;
    }
  } catch (err) {
    console.warn("api.js: could not read impersonation token", err);
  }
  return config;
});

export default api;

export function formatApiError(detail, fallback = "Something went wrong. Please try again.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
